export enum EModeFacturation {
    SV = "SESAM-Vitale",
    DEGRADE = "Dégradé",
		PAPIER = "Papier"
}